var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNotificationInactive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m23.885 16.198-2.728-9.367c-1.199-4.124-5.19-6.94-9.68-6.828-4.488.112-8.32 3.121-9.292 7.298l-2.11 9.047c-.207.888.02 1.817.617 2.526.598.71 1.5 1.122 2.455 1.123H6.93C7.428 22.326 9.577 24 12.072 24s4.645-1.674 5.141-4.003h3.64c.984 0 1.91-.439 2.505-1.184.595-.745.79-1.713.528-2.615h-.001zm-11.813 5.798c-1.329-.006-2.511-.806-2.954-2h5.909c-.443 1.194-1.626 1.994-2.955 2zm9.616-4.394a1.06 1.06 0 0 1-.84.395H3.148a1.07 1.07 0 0 1-.819-.374.964.964 0 0 1-.205-.842l2.11-9.047c.765-3.278 3.773-5.64 7.297-5.727 3.523-.088 6.657 2.12 7.601 5.355l2.728 9.368c.09.3.027.623-.171.872z",
  fill: "#171717",
  fillRule: "evenodd"
})));

export default __webpack_public_path__ + "static/media/notification-inactive.1f55ee9a.svg";
export { SvgNotificationInactive as ReactComponent };